import React from "react";

import PropTypes from "prop-types";

import { ListItem, ListItemIcon, ListItemText } from "@mui/material";

import { COLORS } from "../../../Constant/COLORS";

import { TypoPoppBlue } from "../../../Components/Typo";
import { CircleBox, TypoMiddle } from "../../../Components/CustomListItemsComponents";

const CustomListItem = ({ listIndex, title, desc }) => {
  return (
    <ListItem alignItems="flex-start">
      <ListItemIcon>
        <CircleBox bgcolor={COLORS.blue}>
          <TypoMiddle color="white">{listIndex}</TypoMiddle>
        </CircleBox>
      </ListItemIcon>
      <ListItemText>
        <TypoPoppBlue mb={1.5} variant="h6" fontWeight={600}>
          {title}
        </TypoPoppBlue>
        <TypoPoppBlue>{desc}</TypoPoppBlue>
      </ListItemText>
    </ListItem>
  );
};

CustomListItem.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  desc: PropTypes.string,
};

export default CustomListItem;
